import { TDevice } from "./Devices";

export enum NotificationType {
  ERROR = "error",
  INFO = "info",
}

export type TNotification = {
  _id: string;
  device_id: string;
  account_id: string;
  event_id?: string;
  device: TDevice;

  type: NotificationType;

  message: string;
  details: string;
  isRead: boolean;
  created_at: Date;
  updated_at: Date;
};
